export const getProductUrl = (siteUrl: string, productId: string) =>
  `${siteUrl}${siteUrl.endsWith('/') ? '' : '/'}product/${productId}`;
